import { Loader, Stack, Text, Title } from "@mantine/core";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { OrganizationInvitesPanel } from "../../components/OrganizationInvitesPanel/OrganizationInvitesPanel";
import { useActiveOrganization } from "../../hooks/useActiveOrganization";

export const Route = createFileRoute("/settings/invites")({
	component: InvitesRoute,
});

function InvitesRoute() {
	const { activeOrganization, loading } = useActiveOrganization();
	const isAdmin = activeOrganization?.role === "ADMIN";
	const navigate = useNavigate();

	useEffect(() => {
		if (loading) return;
		if (!isAdmin) {
			navigate({ to: "/settings/account" });
		}
	}, [loading, isAdmin, navigate]);

	if (loading || !isAdmin || !activeOrganization) {
		return (
			<div className="flex items-center justify-center min-h-[40vh]">
				<Loader size="lg" />
			</div>
		);
	}

	return (
		<Stack gap="lg">
			<Stack gap="xs">
				<Title order={2}>Invitations</Title>
				<Text c="dimmed">Invite people to your organization by email.</Text>
			</Stack>
			<OrganizationInvitesPanel organizationId={activeOrganization.id} />
		</Stack>
	);
}
